import React from "react";

import { legendItemStyle, legendStyle } from "./style";

export const WmsGetLegendGraphic = ({ customLegendStyle = legendStyle, legendAsJson, description }) => {
  const entries = legendAsJson.Legend[0].rules[0].symbolizers[0].Raster.colormap.entries;
  const entrySample = {
    label: "Nuts",
    quantity: "2320",
    color: "#5A7C30",
  };

  return (
    <div style={customLegendStyle}>
      <div>
        <b>Land cover/crop types</b>
      </div>

      {entries.map((entry) => (
        <div key={entry.label}>
          <span style={legendItemStyle(entry.color)}></span>
          {` [${entry.quantity}] ${entry.label}`}
        </div>
      ))}
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {description}
        </span>
      </div>
    </div>
  );
};
